import { render } from "./vendorMater.vue?vue&type=template&id=4ef15ca8&scoped=true"
import script from "./vendorMater.vue?vue&type=script&lang=js"
export * from "./vendorMater.vue?vue&type=script&lang=js"

import "./vendorMater.vue?vue&type=style&index=0&id=4ef15ca8&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ef15ca8"]])

export default __exports__